<template>
  <v-select
    v-model="selectedUso"
    :items="usosCFDI"
    item-text="Descripcion"
    item-value="IdUsoCFDI"
    label="Selecciona Uso CFDI"
    clearable
    @change="onSelect"
    outlined dense
    :rules="[rules.ruleRequired]"
  ></v-select>
</template>

<script>
export default {
  props: {
    tipoPersona: { // 'F' = Física, 'M' = Moral
      type: String,
      required: true
    }
  },
  data() {
    return {
      usosCFDI: [],
      selectedUso: null,
    };
  },
  computed: {
    rules() {
        return this.$rules;
    },
  },
  watch: {
    tipoPersona: {
      immediate: true,
      handler(newTipo) {
        this.fetchCFDI(newTipo);
      }
    }
  },
  methods: {
    fetchCFDI(tipo) {
       this.$http.get('catalogo/uso-cfdi', { params: { Tipo: tipo } })
        .then(response => {
          if (response.status === 200) {
            this.usosCFDI  = response.data;
          }
        })
        .finally(() => {
        });
    },
    onSelect(value) {
      // Aquí podrías emitir un evento al padre si quieres
      this.$emit('select', value);
    }
  }
};
</script>
